import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { AdminLayout } from "@/components/admin-layout";
import { DashboardPage } from "@/pages/dashboard";
import { FormsPage } from "@/pages/forms";
import { FormDetailPage } from "@/pages/form-detail";
import { UsersPage } from "@/pages/users";
import { SettingsPage } from "@/pages/settings";
import { DataNacePage } from "@/pages/data-nace";
import { DataEk3Page } from "@/pages/data-ek3";
import { DataRegionsPage } from "@/pages/data-regions";
import { ClientsPage } from "@/pages/clients";
import { ClientDetailPage } from "@/pages/client-detail";
import { ProjectsPage } from "@/pages/projects";
import { ProjectDetailPage } from "@/pages/project-detail";
import { CallPeriodsPage } from "@/pages/call-periods";
import { CallPeriodDetailPage } from "@/pages/call-period-detail";
import { RemindersPage } from "@/pages/reminders";
import { LoginPage } from "@/pages/login";
import { checkAuth } from "@/lib/api";
import { Loader2 } from "lucide-react";

function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="size-8 animate-spin text-accent" />
        <p className="text-sm text-muted-foreground">Yükleniyor...</p>
      </div>
    </div>
  );
}

export function App() {
  const [authState, setAuthState] = useState<"loading" | "authenticated" | "unauthenticated">("loading");

  useEffect(() => {
    checkAuth().then((ok) => {
      setAuthState(ok ? "authenticated" : "unauthenticated");
    });
  }, []);

  if (authState === "loading") {
    return <LoadingScreen />;
  }

  if (authState === "unauthenticated") {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="forms" element={<FormsPage />} />
        <Route path="forms/:id" element={<FormDetailPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="data/nace" element={<DataNacePage />} />
        <Route path="data/ek3" element={<DataEk3Page />} />
        <Route path="data/regions" element={<DataRegionsPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/:id" element={<ClientDetailPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:id" element={<ProjectDetailPage />} />
        <Route path="call-periods" element={<CallPeriodsPage />} />
        <Route path="call-periods/:id" element={<CallPeriodDetailPage />} />
        <Route path="reminders" element={<RemindersPage />} />
      </Route>
    </Routes>
  );
}
